export default __webpack_public_path__ + "static/media/likeUnActiveIcon.d42159d0.svg";